export default "__VITE_ASSET__BImzWcV1__"